import React from "react";
import Box from "@mui/material/Box";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Fonts } from "shared/constants/AppEnums";
import { CustomerMasterData } from "types/models/customerMaster/CustomerMasterApp";
import { Button } from "@mui/material";
import { useNavigate } from "react-router";

interface CustomerProps {
  customer: CustomerMasterData;
  onBack?: () => void;
}

const CustomerUpdateHeader: React.FC<CustomerProps> = ({ customer, onBack }) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    if (onBack) {
      onBack();
    }
    navigate("/customerCare/list");
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexDirection: { xs: "column", sm: "row" },
        pb: 5,
        mb: 2,
        borderBottom: "1px solid #E5E4EA",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={handleBackClick}
          sx={{
            textTransform: "none",
            color: "black",
            padding: 0,
            minWidth: "auto",
          }}
        />
        <Box
          component="h3"
          sx={{
            color: "text.primary",
            fontWeight: Fonts.BOLD,
            fontSize: 16,
            ml: 0.5,
            mb: { xs: 1, sm: 0 },
          }}
        >
          {customer.PageID ? "Edit Customer" : "Add New Customer"}
        </Box>
      </Box>
    </Box>
  );
};

export default CustomerUpdateHeader;
